import React from 'react';

const BlogLeftSidebar = () => {

    return (
      <>
        <div id="preloader">
          <div id="status">
            <img src="images/preloader.gif" id="preloader_image" alt="loader" />
          </div>
        </div>
        <a href="javascript:;" id="return-to-top">
          <i class="fas fa-angle-double-up"></i>
        </a>
        <div class="main-header-wrapper float_left">
          <div class="sb-main-header">
            <div class="top-header-section">
              <div class="container">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-8">
                    <div class="sb-top-left-section">
                      <div>
                        <a href="/mailto:madisch@example.com">
                          <span>
                            <i class="fas fa-envelope"></i>
                          </span>
                          &nbsp; &nbsp;madisch@example.com
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-4 p-0">
                    <div class="sb-top-right-section">
                      <ul>
                        <li>
                          <ul class="d-xl-flex d-lg-flex d-md-none d-sm-none d-none">
                            <li>
                              <a href="www.facebook.com">
                                <i class="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a href="www.twitter.com">
                                <i class="fab fa-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="www.instagram.com">
                                <i class="fab fa-instagram"></i>
                              </a>
                            </li>
                            <li>
                              <a href="www.pinterest.com">
                                <i class="fab fa-pinterest-p"></i>
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li class="login-btn">
                          <span>
                            <a href="/login">Login</a>/
                            <a href="/register">Register</a>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mid-header-section d-xl-block d-lg-block d-md-none d-sm-none d-none">
              <div class="container">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                    <div class="sb_logo_wrapper">
                      <a href="/index">
                        <img
                          src="images/logo2.png"
                          alt="img"
                          style={{ height: "80px" }}
                        />
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                    <div class="sb-mid-right-section">
                      <ul>
                        <li>
                          <a href="/contactUs">
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <a href="/contactUs">
                            121 Waldeck Street
                            <br />
                            NY, USA
                          </a>
                        </li>
                        <li>
                          <a href="/contactUs">
                            <i class="fas fa-phone"></i>
                          </a>
                          <a href="/contactUs">
                            Call Us 24/7
                            <br />
                            +80 (234) 123 567 12
                          </a>
                        </li>
                        <li class="border-none pe-0">
                          <a href="/contactUs">
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <a href="/contactUs">
                            Mon - Fri: 8:00 - 20:00
                            <br />
                            Sat - Sun: 9:00 - 16:00
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="menu-items-wrapper d-xl-block d-lg-block d-md-none d-sm-none d-none ">
              <div class="container">
                <div class="row">
                  <div class="col-lg-8 col-md-6">
                    <nav class="navbar navbar-expand-lg">
                      <ul class="navbar-nav">
                        <li class="nav-item ps-rel">
                          <a class="nav-link" href="javascript:;">
                            Home
                            <span>
                              <i class="fas fa-chevron-right"></i>
                            </span>
                          </a>
                          <ul class="dropdown-items">
                            <li>
                              <a href="/index">Home 01</a>
                            </li>
                            <li>
                              <a href="/index2">Home 02</a>
                            </li>
                            <li>
                              <a href="/index3">Home 03</a>
                            </li>
                          </ul>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="javascript:;">
                            Pages
                            <span>
                              <i class="fas fa-chevron-right"></i>
                            </span>
                          </a>
                          <ul class="dropdown-items">
                            <li>
                              <a href="/admin/advertisement">About Us</a>
                            </li>
                            <li>
                              <a href="/all-dr">Doctors</a>
                            </li>
                            <li>
                              <a href="/dr-single">Doctor single</a>
                            </li>
                            <li>
                              <a href="/appoinment">Appoinment</a>
                            </li>
                            <li>
                              <a href="/error404">404</a>
                            </li>
                          </ul>
                        </li>
                        {/* <li class="nav-item ps-rel">
                          <a class="nav-link" href="javascript:;">
                            Services
                            <span>
                              <i class="fas fa-chevron-right"></i>
                            </span>
                          </a>
                          <ul class="dropdown-items">
                            <li>
                              <a href="/service">
                                Service
                                <span>
                                  <i class="fas fa-chevron-right"></i>
                                </span>
                              </a>
                              <ul class="sub-dropdown">
                                <li>
                                  <a href="/covid-single">Covid 19</a>
                                </li>
                                <li>
                                  <a href="/stathoscope-single">
                                    Full Stathoscope
                                  </a>
                                </li>
                                <li>
                                  <a href="/heart-specialist">
                                    Heart Specialist
                                  </a>
                                </li>
                                <li>
                                  <a href="/blood-bank">Blood Bank</a>
                                </li>
                                <li>
                                  <a href="/disable">For Disable</a>
                                </li>
                                <li>
                                  <a href="/psychiatrist">Psychiatrist</a>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <a href="/single-details">Service Details</a>
                            </li>
                          </ul>
                        </li> */}
                        {/* <li class="nav-item ps-rel">
                          <a class="nav-link" href="javascript:;">
                            Gallery
                            <span>
                              <i class="fas fa-chevron-right"></i>
                            </span>
                          </a>
                          <ul class="dropdown-items">
                            <li>
                              <a href="/gallery">3 Columns</a>
                            </li>
                            <li>
                              <a href="/gallery2">4 Columns</a>
                            </li>
                            <li>
                              <a href="/gallery3">5 Columns</a>
                            </li>
                          </ul>
                        </li> */}
                        {/* <li class="nav-item ps-rel">
                          <a class="nav-link" href="javascript:;">
                            Blog
                            <span>
                              <i class="fas fa-chevron-right"></i>
                            </span>
                          </a>
                          <ul class="dropdown-items">
                            <li>
                              <a href="/blog-left-sidebar">Blog Left-sidebar</a>
                            </li>
                            <li>
                              <a href="/blog-right-sidebar">
                                Blog Right-sidebar
                              </a>
                            </li>
                            <li>
                              <a href="javascript:;">
                                Blog-single
                                <span>
                                  <i class="fas fa-chevron-right"></i>
                                </span>
                              </a>
                              <ul class="sub-dropdown">
                                <li>
                                  <a href="/blog-single">Blog single</a>
                                </li>
                                <li>
                                  <a href="/blog-single-slider">
                                    Blog single slider
                                  </a>
                                </li>
                                <li>
                                  <a href="/blog-single-video">
                                    Blog single video
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li> */}
                        {/* <li class="nav-item ps-rel">
                          <a class="nav-link" href="javascript:;">
                            Shortcode
                            <span>
                              <i class="fas fa-chevron-right"></i>
                            </span>
                          </a>
                          <div class="dropdown-items mega-menu">
                            <ul>
                              <li>
                                <a href="/accordion">Accordion</a>
                              </li>
                              <li>
                                <a href="/client">Client</a>
                              </li>
                              <li>
                                <a href="/counter">Counter</a>
                              </li>
                              <li>
                                <a href="/form">Form</a>
                              </li>
                            </ul>
                            <ul>
                              <li>
                                <a href="/alert">Alert</a>
                              </li>
                              <li>
                                <a href="/icon">Icon</a>
                              </li>
                              <li>
                                <a href="/list">List</a>
                              </li>
                              <li>
                                <a href="/pricing-table">Pricing Table</a>
                              </li>
                            </ul>
                            <ul>
                              <li>
                                <a href="/button">Button</a>
                              </li>
                              <li>
                                <a href="/tab">Tabs</a>
                              </li>
                              <li>
                                <a href="/team">Team</a>
                              </li>
                              <li>
                                <a href="/testimonials">Testimonial</a>
                              </li>
                            </ul>
                            <ul>
                              <li>
                                <a href="/portfolio">Portfolio</a>
                              </li>
                              <li>
                                <a href="/social-icon">Social Icon</a>
                              </li>
                            </ul>
                          </div>
                        </li> */}
                        <li>
                          <a href="/admin/category">Category</a>
                        </li>
                        <li>
                          <a href="/admin/subscripers">subscribers</a>
                        </li>
                        <li>
                          <a href="/admin/user">User</a>
                        </li>
                        <li>
                          <a href="/admin/subscripersHistory">
                            subscribersHistory
                          </a>
                        </li>
                        <li>
                          <a href="/admin/comments">Comments</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="/contactUs">
                            Contact Us
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="/admin/advertisement">
                            Advertisement
                          </a>
                        </li>
                        <li>
                          <a href="/admin/pages">Pages</a>
                        </li>
                        <li>
                          <a href="/admin/posts">Posts</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <form class="d-flex justify-content-end ps-rel">
                      <input class="" placeholder="Search" />
                      <span>
                        <i class="fas fa-search"></i>
                      </span>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="mobile-menu-wrapper d-xl-none d-lg-none d-md-block d-sm-block">
              <div class="container">
                <div class="row">
                  <div class=" col-md-6 col-sm-6 col-6">
                    <div class="mobile-logo">
                      <a href="javascript:;">
                        <img
                          src="images/logo2.png"
                          alt="img"
                          style={{ height: "80px" }}
                        />
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-6">
                    <div class="d-flex  justify-content-end">
                      <div class="d-flex align-items-center">
                        <div
                          class="toggle-main-wrapper mt-2"
                          id="sidebar-toggle"
                        >
                          <span class="line"></span>
                          <span class="line"></span>
                          <span class="line"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="sidebar">
              <div class="sidebar_logo">
                <a href="javascript:;">
                  <img
                    src="images/logo2.png"
                    alt="img"
                    style={{ height: "80px" }}
                  />
                </a>
              </div>
              <div id="toggle_close">&times;</div>
              <div id="cssmenu">
                <ul class="float_left">
                  <li class="has-sub">
                    <a href="javascript:;">Home</a>
                    <ul>
                      <li>
                        <a href="/index">Home 01</a>
                      </li>
                      <li>
                        <a href="/index2">Home 02</a>
                      </li>
                      <li>
                        <a href="/index3">Home 03</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="/about-us">about</a>
                  </li>
                  <li>
                    <a href="/all-dr">Doctors</a>
                  </li>
                  <li>
                    <a href="/dr-single">Doctor Single</a>
                  </li>
                  <li>
                    <a href="/appoinment">Appointment</a>
                  </li>
                  <li class="has-sub">
                    <a href="javascript:;">Services</a>
                    <ul>
                      <li>
                        <a href="/service">Service</a>
                      </li>
                      <li>
                        <a href="/single-details">Service Details</a>
                      </li>
                    </ul>
                  </li>
                  <li class="has-sub">
                    <a href="javascript:;">Gallery</a>
                    <ul>
                      <li>
                        <a href="/gallery">3 Columns</a>
                      </li>
                      <li>
                        <a href="/gallery2">4 Columns</a>
                      </li>
                      <li>
                        <a href="/gallery3">5 Columns</a>
                      </li>
                    </ul>
                  </li>
                  <li class="has-sub">
                    <a href="javascript:;">Blog</a>
                    <ul>
                      <li>
                        <a href="/blog-left-sidebar">Blog Left-sidebar</a>
                      </li>
                      <li>
                        <a href="/blog-right-sidebar">Blog Right-sidebar</a>
                      </li>
                      <li class="has-sub">
                        <a class="sub-icon">Blog Single</a>
                        <ul class="m-sub-dropdown">
                          <li>
                            <a href="/blog-single">Blog single</a>
                          </li>
                          <li>
                            <a href="/blog-single-slider">Blog single slider</a>
                          </li>
                          <li>
                            <a href="/blog-single-video">Blog single video</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li class="has-sub">
                    <a href="javascript:;">Shortcode</a>
                    <ul>
                      <li>
                        <a href="/accordion">Accordion</a>
                      </li>
                      <li>
                        <a href="/client">Client</a>
                      </li>
                      <li>
                        <a href="/counter">Counter</a>
                      </li>
                      <li>
                        <a href="/form">Form</a>
                      </li>
                      <li>
                        <a href="/alert">Alert</a>
                      </li>
                      <li>
                        <a href="/icon">Icon</a>
                      </li>
                      <li>
                        <a href="/list">List</a>
                      </li>
                      <li>
                        <a href="/pricing-table">Pricing Table</a>
                      </li>
                      <li>
                        <a href="/button">Button</a>
                      </li>
                      <li>
                        <a href="/tab">Tabs</a>
                      </li>
                      <li>
                        <a href="/team">Team</a>
                      </li>
                      <li>
                        <a href="/testimonials">Testimonial</a>
                      </li>
                      <li>
                        <a href="/portfolio">Portfolio</a>
                      </li>
                      <li>
                        <a href="/social-icon">Social Icon</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="/contactUs">contact us</a>
                  </li>

                  <li class="border-none">
                    <a href="/error404">404</a>
                  </li>
                  <li class="input-group border-none my-3 mx-2">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                    />
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      id="button-addon2"
                    >
                      <i class="fas fa-search"></i>
                    </button>
                  </li>
                  <li class="border-none">
                    <ul class="social-icon">
                      <li>
                        <a href="/www.facebook.com">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/www.twitter.com">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/www.instagram.com">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/www.pinterest.com">
                          <i class="fab fa-pinterest-p"></i>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="blog-page-main-container float_left ptb-100">
          <div class="container">
            <div class="d-flex justify-content-end mb-3">
              <button
                class="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#addBlogModal"
              >
                + Add
              </button>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div class="blog-box p-0 resp-30">
                      <div class="img-icon">
                        <img
                          src="images/dr1.jpg"
                          alt="img"
                          style={{ width: "410px", height: "270px" }}
                        />
                        <div class="img-overlay"></div>
                        <p class="text-center">
                          08
                          <br />
                          july
                        </p>
                      </div>
                      <div class="blog-content">
                        <h3>
                          <a href="/blog-single">
                            Spending More and Getting Less for Health Care
                          </a>
                        </h3>
                        <ul>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-user"></i> by John Doe
                            </a>
                          </li>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-comments"></i>Comments 02
                            </a>
                          </li>
                        </ul>
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout.
                        </p>
                        <a href="/blog-single" class="r-btn">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div class="blog-box p-0 resp-30">
                      <div class="img-icon">
                        <img
                          src="images/dr2.jpg"
                          alt="img"
                          style={{ width: "410px", height: "270px" }}
                        />
                        <div class="img-overlay"></div>
                        <p class="text-center">
                          08
                          <br />
                          july
                        </p>
                      </div>
                      <div class="blog-content">
                        <h3>
                          <a href="/blog-single">
                            Spending More and Getting Less for Health Care
                          </a>
                        </h3>
                        <ul>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-user"></i> by John Doe
                            </a>
                          </li>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-comments"></i>Comments 02
                            </a>
                          </li>
                        </ul>
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout.
                        </p>
                        <a href="/blog-single" class="r-btn">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div class="blog-box p-0 resp-30">
                      <div class="img-icon">
                        <img
                          src="images/dr3.jpg"
                          alt="img"
                          style={{ width: "410px", height: "270px" }}
                        />
                        <div class="img-overlay"></div>
                        <p class="text-center">
                          08
                          <br />
                          july
                        </p>
                      </div>
                      <div class="blog-content">
                        <h3>
                          <a href="/blog-single">
                            Spending More and Getting Less for Health Care
                          </a>
                        </h3>
                        <ul>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-user"></i> by John Doe
                            </a>
                          </li>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-comments"></i>Comments 02
                            </a>
                          </li>
                        </ul>
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout.
                        </p>
                        <a href="/blog-single" class="r-btn">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div class="blog-box p-0 resp-30">
                      <div class="img-icon">
                        <img
                          src="images/dr4.jpg"
                          alt="img"
                          style={{ width: "410px", height: "270px" }}
                        />
                        <div class="img-overlay"></div>
                        <p class="text-center">
                          08
                          <br />
                          july
                        </p>
                      </div>
                      <div class="blog-content">
                        <h3>
                          <a href="/blog-single">
                            Spending More and Getting Less for Health Care
                          </a>
                        </h3>
                        <ul>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-user"></i> by John Doe
                            </a>
                          </li>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-comments"></i>Comments 02
                            </a>
                          </li>
                        </ul>
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout.
                        </p>
                        <a href="/blog-single" class="r-btn">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div class="blog-box p-0 resp-30">
                      <div class="img-icon">
                        <img
                          src="images/dr5.jpg"
                          alt="img"
                          style={{ width: "410px", height: "270px" }}
                        />
                        <div class="img-overlay"></div>
                        <p class="text-center">
                          08
                          <br />
                          july
                        </p>
                      </div>
                      <div class="blog-content">
                        <h3>
                          <a href="/blog-single">
                            Spending More and Getting Less for Health Care
                          </a>
                        </h3>
                        <ul>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-user"></i> by John Doe
                            </a>
                          </li>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-comments"></i>Comments 02
                            </a>
                          </li>
                        </ul>
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout.
                        </p>
                        <a href="/blog-single" class="r-btn">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div class="blog-box p-0 resp-30">
                      <div class="img-icon">
                        <img
                          src="images/dr6.jpg"
                          alt="img"
                          style={{ width: "410px", height: "270px" }}
                        />
                        <div class="img-overlay"></div>
                        <p class="text-center">
                          08
                          <br />
                          july
                        </p>
                      </div>
                      <div class="blog-content">
                        <h3>
                          <a href="/blog-single">
                            Spending More and Getting Less for Health Care
                          </a>
                        </h3>
                        <ul>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-user"></i> by John Doe
                            </a>
                          </li>
                          <li>
                            <a href="javascript:;">
                              <i class="far fa-comments"></i>Comments 02
                            </a>
                          </li>
                        </ul>
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout.
                        </p>
                        <a href="/blog-single" class="r-btn">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-main-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                <div class="sb-footer-section">
                  <div class="footer-logo">
                    <img src="images/footer-logo.png" alt="img" />
                  </div>
                  <ul>
                    <li>
                      <a href="javascript:;">
                        <i class="fas fa-map-marker-alt"></i>ADDRESS
                        <br />
                        121 Waldeck Street, NY, USA
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;">
                        <i class="fas fa-phone"></i>PHONE
                        <br />
                        0800-123456, 0800-123489
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;">
                        <i class="fas fa-envelope"></i>EMAIL
                        <br />
                        medisch@example.com
                      </a>
                    </li>
                    <li>
                      <ul class="footer-media">
                        <li>
                          <a href="javascript:;">
                            <i class="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:;">
                            <i class="fab fa-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:;">
                            <i class="fab fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:;">
                            <i class="fab fa-pinterest-p"></i>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-2 col-md-6 col-sm-12 col-12">
                <div class="links">
                  <h4>Useful Links</h4>
                  <ul>
                    <li>
                      <a href="/about-us">
                        <i class="fas fa-angle-right"></i>About Us
                      </a>
                    </li>
                    <li>
                      <a href="/service">
                        <i class="fas fa-angle-right"></i>Service
                      </a>
                    </li>
                    <li>
                      <a href="/gallery">
                        <i class="fas fa-angle-right"></i>Gallery
                      </a>
                    </li>
                    <li>
                      <a href="/blog-single">
                        <i class="fas fa-angle-right"></i>Blog
                      </a>
                    </li>
                    <li>
                      <a href="/appoinment">
                        <i class="fas fa-angle-right"></i>Appoinments
                      </a>
                    </li>
                    <li>
                      <a href="/contactUs">
                        <i class="fas fa-angle-right"></i>Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                <h4>Recent Posts</h4>
                <div class="img-link">
                  <ul>
                    <li>
                      <img src="images/post-img1.jpg" alt="img" />
                      <div class="content">
                        <h5 class="pb-0">
                          <a href="/blog-single">Best Surgery</a>
                        </h5>
                        <p>
                          Our best surgery
                          <br />
                          available here.
                        </p>
                      </div>
                    </li>
                    <li>
                      <img src="images/post-img2.jpg" alt="img" />
                      <div class="content">
                        <h5 class="pb-0">
                          <a href="/blog-single">Best Doctors</a>
                        </h5>
                        <p>
                          Our best surgery
                          <br />
                          available here.
                        </p>
                      </div>
                    </li>
                    <li>
                      <img src="images/post-img3.jpg" alt="img" />
                      <div class="content">
                        <h5 class="pb-0">
                          <a href="/blog-single">Best Services</a>
                        </h5>
                        <p>
                          Our best surgery
                          <br />
                          available here.
                        </p>
                      </div>
                    </li>
                    <li>
                      <img src="images/post-img4.jpg" alt="img" />
                      <div class="content">
                        <h5 class="pb-0">
                          <a href="/blog-single">Best Rooms</a>
                        </h5>
                        <p>
                          Our best surgery
                          <br />
                          available here.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                <div class="time-wrapper">
                  <div>
                    <h4>Days</h4>
                    <ul>
                      <li>Monday</li>
                      <li>Tuesday</li>
                      <li>Wednesday</li>
                      <li>Thrusday</li>
                      <li>Friday</li>
                      <li>Saturday</li>
                      <li>Sunday</li>
                    </ul>
                  </div>
                  <div>
                    <h4>Opening Hours</h4>
                    <ul>
                      <li>08.00 - 10.00</li>
                      <li>09.00 - 11.00</li>
                      <li>10.00 - 12.00</li>
                      <li>11.00 - 01.00</li>
                      <li>12.00 - 02.00</li>
                      <li>01.00 - 02.00</li>
                      <li>02.00 - 04.00</li>
                    </ul>
                  </div>
                </div>
                <div id="newsletter">
                  <h5>Sign Up for Newsletter</h5>
                  <div class="input-box">
                    <input
                      type="text"
                      name="text"
                      id="text"
                      placeholder="Enter Your Email"
                    />
                    <a href="javascript:;">
                      <i class="fas fa-paper-plane"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section>
            <div class="container">
              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                  <p>
                    © Copyright 2022 - 23 Design by{" "}
                    <a href="https://webstrot.com/">Webstrot</a> | All Rights
                    Reserved.
                  </p>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                  <p class="last-para">
                    Private Policy | Terms and Conditions.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div
          class="modal fade"
          id="addBlogModal"
          tabindex="-1"
          aria-labelledby="addBlogModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content p-4">
              <div class="modal-header">
                <h5 class="modal-title" id="addBlogModalLabel">
                  Add Blog Post
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body pt-0">
                <form>
                  <div class="mb-3">
                    <label for="blogTitle" class="form-label">
                      Title
                    </label>
                    <input type="text" class="form-control" id="blogTitle" />
                  </div>

                  <div class="mb-3">
                    <label for="blogCategory" class="form-label">
                      Category
                    </label>
                    <select class="form-select" id="blogCategory">
                      <option value="">Select category</option>
                      <option value="clinical">Clinical</option>
                      <option value="general">General</option>
                      <option value="law">Law</option>
                      <option value="culture">Culture</option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label for="bannerImage" class="form-label">
                      Banner Image
                    </label>
                    <input
                      class="form-control"
                      type="file"
                      id="bannerImage"
                      accept="image/*"
                    />
                  </div>

                  <div class="mb-3">
                    <label for="blogContent" class="form-label">
                      Content
                    </label>
                    <textarea
                      class="form-control"
                      id="blogContent"
                      rows="3"
                    ></textarea>
                  </div>
                </form>
              </div>
              <div class="modal-footer pt-2">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  data-bs-dismiss="modal"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default BlogLeftSidebar;